import React from "react";
import { Box, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ContentPanel = ({ imageUrl, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        borderRadius: 4,
        overflow: 'hidden',
        maxWidth: { xs: '100%', sm: '500px', md: '900px', lg: '1000px' },
        width: '100%',
        mx: 'auto',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(30, 30, 30, 0.85)' : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(12px)',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.palette.mode === 'dark'
          ? '0px 10px 30px rgba(0, 0, 0, 0.5)'
          : '0px 10px 30px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', md: '45%' },
          minHeight: { xs: 250, md: '100%' },
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: { xs: 'none', md: 'block' },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: theme.palette.mode === 'dark'
              ? 'linear-gradient(90deg, rgba(30, 30, 30, 0.9) 0%, rgba(30, 30, 30, 0.5) 50%, rgba(30, 30, 30, 0.1) 100%)'
              : 'linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.1) 100%)',
          }
        }}
      />

      <Box sx={{
        width: { xs: '100%', md: '55%' },
        p: { xs: 3, md: 6 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
        {children}
      </Box>
    </Paper>
  );
};

export default ContentPanel;